/**
 * 示例-列表页-带批量操作
 * luxinwen
 * 2023-01
 */
<template>
  <div class="page">
    <div class="page-main">
      <div class="page-main-content" v-grant="['OSP_TEST_LIST_SAVE', 'OSP_TEST_LIST_BATCH']">
        <Button type="primary" @click="addData" v-grant="'OSP_TEST_LIST_SAVE'">新增信息</Button>
        <Button type="default" @click="batchRemove" v-grant="'OSP_TEST_LIST_BATCH'">批量导出</Button>
        <Button type="error" @click="batchRemove" v-grant="'OSP_TEST_LIST_BATCH'">批量删除</Button>
      </div>
      <div class="page-main-content">
        <sp-table :columns="filterColumns" :data="tableData" :loading="tableLoading" :total="pager.total" :page="pager.pageNum" :page-size="pager.pageSize" @change="changePage" @select="selectData">
          <template slot-scope="params" slot="operation">
            <Button @click="editData(params.row, true)" v-grant="'OSP_TEST_LIST_VIEW'">查看</Button>
            <Button @click="editData(params.row, false)" v-grant="'OSP_TEST_LIST_UPDATE'">编辑</Button>
            <Button type="error" @click="removeData(params.row)" v-grant="'OSP_TEST_LIST_DELETE'">删除</Button>
          </template>
        </sp-table>
      </div>
    </div>

    <!-- 编辑表单 -->
    <edit-drawer v-model="drawerDisplay" :data="drawerData" :flag="drawerFlag" @success="getData"></edit-drawer>
  </div>
</template>

<script>
  import { TEST_STATUS } from '@/util/enum';
  import editDrawer from '../edit/edit-drawer.vue';

  export default {
    components: {
      editDrawer
    },
    data() {
      return {
        tableColumns: [
          {
            type: 'selection',
            width: 52
          },
          {
            title: '标题',
            key: 'name'
          },
          {
            title: '编码',
            key: 'code'
          },
          {
            title: '状态',
            render: (h, params) => {
              return h('span', this.statusList[params.row.status]);
            }
          },
          {
            title: '创建时间',
            key: 'time'
          },
          {
            title: '操作',
            slot: 'operation',
            align: 'center'
          }
        ],
        tableData: [],
        tableLoading: false, // 表格查询状态
        pager: {
          total: 0,     // 总条数
          pageNum: 1,   // 当前页码
          pageSize: 10  // 每页条数
        },
        drawerDisplay: false, // 是否显示编辑抽屉
        drawerData: {},       // 编辑抽屉数据
        drawerFlag: 'add',    // 编辑抽屉状态
        selection: [], // 选中的数据
        statusList: TEST_STATUS
      };
    },
    computed: {
      filterColumns() {
        let val = this.tableColumns;
        let grant = [this.$grant.OSP_TEST_LIST_VIEW, this.$grant.OSP_TEST_LIST_UPDATE, this.$grant.OSP_TEST_LIST_DELETE];
        if (!this.checkGrant(grant)) {
          val = this.tableColumns.filter(item => item.slot !== 'operation');
        }
        return val;
      }
    },
    created() {
      this.getData();
    },
    methods: {
      /**
       * 获取数据
       */
      getData() {
        let data = Object.assign({}, {
          pageNum: this.pager.pageNum,
          pageSize: this.pager.pageSize
        });
        this.$axios({
          url: this.$api.test.queryTestList,
          mock: true,
          data,
          beforeSend: () => {
            this.tableLoading = true;
          },
          complete: () => {
            this.tableLoading = false;
          }
        }).then(data => {
          this.tableData = data.list || [];
          this.pager.total = data.total || 0;
        });
      },
      /**
       * 新增
       */
      addData() {
        this.drawerFlag = 'add';
        this.drawerData = {};
        this.drawerDisplay = true;
      },
      /**
       * 查看、编辑
       */
      editData(row, onlyRoad = false) {
        this.drawerFlag = onlyRoad ? 'show' : 'edit';
        this.drawerData = row;
        this.drawerDisplay = true;
      },
      /**
       * 删除
       */
      removeData(row) {
        this.$confirm(`是否确定删除【${row.name}】？`).then(() => {
          this.$axios({
            url: this.$api.test.deleteTest,
            mock: true,
            data: {
              id: row.id
            },
            loading: true
          }).then(data => {
            this.notice({
              type: 'success',
              desc: '删除成功'
            });
            this.getData();
          });
        });
      },
      /**
       * 批量删除
       */
      batchRemove() {
        if (!this.selection.length) {
          this.notice('请先选择数据');
          return;
        }
        let str = '是否批量删除以下数据？';
        let ids = [];
        this.selection.forEach(item => {
          str += `<p>【${item.name}】</p>`;
          ids.push(item.id);
        });
        this.$confirm(str).then(() => {
          this.$axios({
            url: this.$api.test.deleteTest,
            mock: true,
            data: {
              ids
            },
            loading: true
          }).then(data => {
            this.notice({
              type: 'success',
              desc: '批量删除成功'
            });
            this.selection = [];
            this.getData();
          });
        });
      },
      /**
       * 选择数据
       */
      selectData(selection) {
        this.selection = selection;
      },
      /**
       * 切换页码或每条页数
       */
      changePage(pager) {
        this.pager.pageNum = pager.page;
        this.pager.pageSize = pager.pageSize;
        this.getData();
      }
    }
  };
</script>